import { useEffect, useState } from 'react';

function GoalsView({ initialText, onSave, onNavigateMain }) {
  const [draft, setDraft] = useState(initialText || '');
  const [saveState, setSaveState] = useState('idle');
  const [errorMessage, setErrorMessage] = useState('');

  useEffect(() => {
    setDraft(initialText || '');
  }, [initialText]);

  const handleSave = async () => {
    setSaveState('saving');
    setErrorMessage('');
    try {
      await onSave(draft);
      setSaveState('saved');
      setTimeout(() => setSaveState('idle'), 1500);
    } catch (error) {
      setErrorMessage(error.message || '保存に失敗しました');
      setSaveState('error');
    }
  };

  return (
    <div className="page-card">
      <div className="page-header">
        <button className="link-button" type="button" onClick={onNavigateMain}>
          ← メインへ戻る
        </button>
        <h1 className="page-title">目標設定</h1>
      </div>
      <label className="form-label">
        目標
        <textarea
          className="goal-textarea"
          value={draft}
          onChange={(event) => setDraft(event.target.value)}
          rows={10}
        />
      </label>
      <div className="button-row">
        <button
          className="primary-button"
          type="button"
          onClick={handleSave}
          disabled={saveState === 'saving'}
        >
          {saveState === 'saving' ? '保存中...' : '保存'}
        </button>
        {saveState === 'saved' ? (
          <span className="status-text">保存しました</span>
        ) : null}
        {errorMessage && saveState === 'error' ? (
          <span className="form-error">{errorMessage}</span>
        ) : null}
      </div>
    </div>
  );
}

export default GoalsView;
